import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FacilityPrinterData } from '../pages/auto-print-setting/interface/facility-printer-data';
import { UpdateFacilityPrinterRequest } from '../pages/auto-print-setting/interface/update-facility-printer-request';
import { GetFacilityPrinterRequest } from '../pages/auto-print-setting/interface/get-facility-printer-request';
import { CreateFacilityPrinterRequest } from '../pages/auto-print-setting/interface/create-facility-printer-request';

@Injectable({
  providedIn: 'root'
})
export class FacilityPrinterService {

  private baseUrl: string = `${environment.logisticsApiUrl}/facilityPrinter`;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  constructor(private http: HttpClient) { }

  getFacilityPrinter(request: GetFacilityPrinterRequest): Observable<FacilityPrinterData> {
    const url = this.baseUrl + '/getFacilityPrinter';
    return this.http.post<FacilityPrinterData>(url, request, this.httpOptions);
  }

  exportFacilityPrinter(request: GetFacilityPrinterRequest): Observable<any> {
    const url = this.baseUrl + '/exportFacilityPrinter';
    return this.http.post(url, request, { responseType: 'blob'});
  }

  saveFacilityPrinter(request: any): Observable<void> {
    const url = this.baseUrl + '/saveFacilityPrinter';
    return this.http.post<void>(url, request, this.httpOptions);
  }

  deleteFacilityPrinter(seqNo: Number): Observable<any>{
    const url = this.baseUrl + `/deleteFacilityPrinter/${seqNo}`;
    return this.http.delete(url);
  }


}
